<template>
    <tr class="bh-cursor" :class="status" :id="'target-' + data.candidate.id">

        <b-popover :target="'target-' + data.candidate.id" triggers="hover focus" placement="left" :key="data.candidate_info.id">
            <template v-slot:title>
                <b-img height="40" width="40" rounded="circle" alt="ProfileUser" :src="creatorImage" @error="imgError = true"></b-img>
                {{data.candidate.name}} {{data.candidate.lname ? data.candidate.lname : ''}}
            </template>
            <div class="row">
                <div class="col-lg-12 text-center">
                    <CurriculumPreview :user="data.candidate"/>
                </div>
            </div>
        </b-popover>

        <!--ModalDecline-->
        <b-modal centered size="md" title="Bienvenido a Kllaar" hide-footer hide-header v-model="modal_declined">
            <b-form @submit="declineCandidate">
            <div class="target text-center">
                <img src="@/assets/w_logo_max_b.png" alt="" height="50">
                <hr>
                <div class="_option p-2">
                    <h4 class="font-blue">{{data.candidate.name}} {{data.candidate.lname ? data.candidate.lname : ''}}</h4>
                    <div class="mb-3">
                        Vemos que has descartado a este candidato <br>
                        Por favor, compártenos cual es el motivo
                    </div>
                    <b-form-select
                        v-model="form.motivo_declined"
                        :options="motivos"
                        required></b-form-select>
                </div>
                <small>*Esta información es confidencial, sólo se emplea para cuestiones de estadistica.</small>
                <div class="_buttons mt-4">
                    <b-button type="submit" class="b-orange px-3 font-weight-bold" :disabled="loading.declined">
                        <b-spinner v-if="loading.declined" small label="Espere ..." ></b-spinner>
                        Guardar
                    </b-button>
                    <button type="button" class="btn b-gray-lights px-3 font-weight-bold" @click="modal_declined = false">Cancelar</button>
                </div>
            </div>
            </b-form>
        </b-modal>
        <!--./ModalDecline-->
        <!-- <td>
            <i class="far fa-clock" v-if="status == 'send'"></i>
            <i class="fas fa-check" v-if="status == 'aproved'"></i>
            <i class="fas fa-window-close font-red" v-if="status == 'declined'"></i>
        </td>
        <td>
            <i class="fas fa-star font-yellow" v-if="data.is_match && isGold"></i>
        </td>
        <td>
            <strike v-if="status == 'declined'">{{data.candidate_info.name}} {{data.candidate_info.lname ? data.candidate_info.lname : ''}}</strike>
            <span v-else>{{data.candidate_info.name}} {{data.candidate_info.lname ? data.candidate_info.lname : ''}}</span>
        </td>
        <td>

        </td>
        <td>
            <b-dropdown id="dropdown-1" text="Candidato" class="m-0" size="sm" v-if="status != 'declined'">
                <b-dropdown-item @click="showCandidate">Ver perfil</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="modal_declined = true">
                    <i class="fas fa-times font-red"></i> Rechazar candidato {{isGold}}
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="onAccept">
                    <i class="fas fa-check font-green"></i>
                    Candidato Contratado
                </b-dropdown-item>
            </b-dropdown>
        </td> -->
    </tr>
</template>
<style lang="scss">
    .aproved{
        color: #2ECC71;
    }
    .declined{
        color: #E74C3C;
    }
</style>
<script>
import CurriculumPreview from './CurriculumPreview'
export default {
    name: 'CandidateElement',
    props:{
        data: Object,
        jobId: String,
        isMatch: {
            type: Boolean,
            default: false,
        },
        isGold: {
            type: Boolean,
            default: false
        }
    },
    components:{
        'CurriculumPreview': CurriculumPreview
    },
    data() {
        return {
            visibleComponent: true,
            contacted: this.data.contacted,
            status: this.data.status,
            mainProps: {
                blankColor: '#000',
                width: 25,
                height: 25,
            },
            motivos: [{ text: 'Selecciona una opción', value: null },
                        'No cumple con las habilidades que se requiren para el puesto',
                        'Necesita trabajar en su CV',
                        'Falta experiencia para el puesto',
                        'No cumple con la carrera requerida para el puesto',
                        'No cuenta con logros académicos',
                        'Su pitch / presentación no es suficientemente atractivo o convincente'
                    ],
            isFavorite: this.data.favorite,
            isNegotiation: this.data.status == 'negotiation' ? true : false,
            imgError: false,
            defaultImage: require('@/assets/profile/user_empty.png'),
            options: false,
            modal_declined: false,
            loading: {
                declined: false,
                restore: false,
                message: false,
                preview: false,
                conversation: false,
            },
            aproved: false,
            form:{
                candidate_id: this.data.candidate_info.id,
                job_id: this.jobId,
                status: '',
                motivo_declined: '',
            },
            candidatePreview: {}
        }
    },
    computed: {
        creatorImage(){
            return this.data.candidate_info.avatar ? this.data.candidate_info.avatar : this.defaultImage
        },
    },
    methods: {
      sendConversation(){
          let form = {
              job_id: this.jobId,
              user_to: this.data.candidate_info.id,
              title: 'Postulación de empleo'
          }

        //   console.log(form)

        this.loading.conversation = true
        this.api.post('conversation/store', JSON.stringify(form)).then(({data}) => {
            this.toast(data.message)
            this.loading.conversation = false
        })
      },
      setFavorite(){
          let status = !this.isFavorite

          this.isFavorite = status
          this.api.get('enterprise/job/candidates/' + this.jobId + '/favorite/' + this.data.candidate_info.id + '/' + status).then(({data}) => {
              console.log(data)
          }).catch(err => {})
      },
      declineCandidate(e){
          e.preventDefault()

          this.form.status = 'declined'
          this.loading.declined = true

          this.status = 'declined'
          this.api.post('enterprise/job/candidate/feedback', JSON.stringify(this.form)).then(({data}) => {
              this.loading.declined = false
            //   this.visibleComponent = false
              this.modal_declined = false
          }).catch(err => {
            this.loading.declined = false
            this.modal_declined = false
          })
      },
      restoreCandidate(){
          this.form.status = 'read'
          this.form.motivo_declined = ''
          this.loading.restore = true
          this.api.post('enterprise/job/candidate/feedback', JSON.stringify(this.form)).then(({data}) => {
              this.loading.restore = false
            // this.visibleComponent = false
          }).catch(err => {
            this.loading.restore = false
          })
      },
      onContacted(status){

          this.api.get('candidate/contacted?candidate_id=' + this.data.candidate_info.id +'&job_id='+ this.jobId + '&contacted=' + status).then(({data}) => {

          })

      },
      onAccept(){
          this.aproved = true
          this.status = 'aproved'
          this.api.get('candidate/aceptedOnJob?job_id=' + this.jobId + '&candidate_id=' + this.data.candidate_info.id).then(({data}) => {

          }).catch(err => {
              this.aproved = false
          })
      },
    //   messageCandidate(){
    //       this.loading.message = true
    //       this.api.get('message/create/' + this.data.candidate_info.id).then(({data}) => {
    //           this.$router.push('/message/conversation/' + data.conversation_id)
    //           this.loading.message = false
    //       }).catch(err => {
    //           this.loading.message = false
    //       })
    //   },
      toast(message){
            this.$bvToast.toast(message, {
                title: "Kllaar.com",
                variant: 'success',
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true
            })
        },
        showCandidate(){
            console.log('view candidate!')
            let user_id = this.data.candidate_info.id
            console.log(user_id)
            let routeData = this.$router.resolve({path: '/candidate?profile=' + user_id})
            window.open(routeData.href, '_blank')
        }

    },
    created() {
        console.log(this.data)
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/components/CandidateElement.vue